<template>
  <div class="complementary">
    <br-divider class="mb-2"></br-divider>
    <br-list density="large">
      <br-item v-for="(link, index) in links" :key="index" class="text-center">
        <a :href="link.url">{{ link.name }}</a>
      </br-item>
    </br-list>
  </div>
</template>

<script>
import store from "./store/index"

import BrDivider from "../Divider/Divider.ce.vue"
import BrItem from "../Item/Item.ce.vue"
import BrList from "../List/List.ce.vue"

const CookiebarComplementaryArea = {
  name: "BrCookiebarComplementaryArea",
  components: {
    BrDivider,
    BrItem,
    BrList,
  },
  computed: {
    links() {
      return store.getters.links
    },
  },
}

export default CookiebarComplementaryArea
</script>

<style></style>
